import { useState, useContext, createContext } from "react";
import { toast } from "react-toastify";
import { AuthToken, User } from "../models";
import APIKit, { API, setAccessToken } from "../utils/APIKit";
import { LC_AUTH_TOKEN } from "../utils/AppConst";

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */

type ContextType = {
  user: any 
  login: Function,
  logout: Function,
  setUser: Function
  storeUser: Function
};

const authContext = createContext<ContextType>({
  user: null,
  login: () => null,
  logout: () => null,
  setUser: (_: User) => null,
  storeUser: () => null
});

export const ProvideAuth = ({ children }: any) => {
  const auth = useProvideAuth();
  return (
    <authContext.Provider value={auth}>
      {children}
    </authContext.Provider>
  );
}

export const useAuth = () => {
  return useContext(authContext);
}

const useProvideAuth = () => {

  const fetchUserAndToken = () => {
    const authStr = localStorage.getItem(LC_AUTH_TOKEN);
    if (authStr) {
      const authToken = JSON.parse(authStr) as AuthToken;
      setAccessToken(authToken.token.access_token);
      return authToken.user;
    }
    return null;
  }

  const [user, setUser] = useState<any>(fetchUserAndToken());

  const storeUser = (user) => {
    const authStr = localStorage.getItem(LC_AUTH_TOKEN);
    if (authStr) {
      const authToken = JSON.parse(authStr) as AuthToken;
      authToken.user = user;
      localStorage.setItem(LC_AUTH_TOKEN, JSON.stringify(authToken))
      setUser(user)
    }

    return null;
  }

  const login = async (email: string, password: string, remember: boolean = false): Promise<boolean> => {
    const data = {email, password, 'code': 'code'};
    return APIKit.post<AuthToken>(API.AUTH.login, data)
      .then(({data}) => data)
      .then(authToken => {
        localStorage.setItem(LC_AUTH_TOKEN, JSON.stringify(authToken));
        setUser(authToken.user);
        setAccessToken(authToken.token.access_token);
        toast(`Bienvenue M. ${authToken.user.name}, nous sommes content de vous revoir !`, {
          hideProgressBar: true,
          type: 'success'
        });
        return true;
      })
      .catch(_ => false);
  }

  const logout = (): Promise<any> => {
    setUser(null);
    return APIKit.post(API.AUTH.logout).finally(() => {
      toast("Vous vous êtes déconnecté avec succès !", {
        hideProgressBar: true,
        type: 'info'
      });
      localStorage.removeItem(LC_AUTH_TOKEN);
    });
  };

  return {
    setUser,
    user,
    login,
    logout,
    storeUser
  };
}
